var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitch2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.64 414.06C33.94 414.06 25.21 406.3 25.21 395.64C25.21 362.47 25.21 97.16 25.21 64C25.21 54.3 32.97 45.58 43.64 45.58C46.22 45.58 59.15 45.58 82.42 45.58C82.42 51.98 82.42 55.53 82.42 56.24C82.42 70.79 94.06 83.39 109.58 83.39C109.58 83.39 109.58 83.39 109.58 83.39C124.12 83.39 136.73 71.76 136.73 56.24C136.73 55.6 136.73 52.36 136.73 46.55L169.7 46.55C169.7 52.95 169.7 56.5 169.7 57.21C169.7 71.76 181.33 84.36 196.85 84.36C196.85 84.36 196.85 84.36 196.85 84.36C211.39 84.36 224 72.73 224 57.21C224 56.5 224 52.95 224 46.55L256.97 46.55C256.97 52.95 256.97 56.5 256.97 57.21C256.97 71.76 268.61 84.36 284.12 84.36C284.12 84.36 284.12 84.36 284.12 84.36C298.67 84.36 311.27 72.73 311.27 57.21C311.27 56.5 311.27 52.95 311.27 46.55L344.24 46.55C344.24 52.95 344.24 56.5 344.24 57.21C344.24 71.76 355.88 84.36 371.39 84.36C371.39 84.36 371.39 84.36 371.39 84.36C385.94 84.36 398.55 72.73 398.55 57.21C398.55 56.5 398.55 52.95 398.55 46.55C421.82 46.55 434.75 46.55 437.33 46.55C447.03 46.55 455.76 54.3 455.76 64.97C455.76 85.33 455.76 248.24 455.76 268.61C455.76 272.48 458.67 276.36 463.52 276.36C468.36 276.36 471.27 273.45 471.27 268.61C471.27 248.24 471.27 85.33 471.27 64.97C471.27 46.55 456.73 32 438.3 32C435.72 32 422.79 32 399.52 32C399.52 29.09 399.52 27.47 399.52 27.15C399.52 12.61 387.88 0 372.36 0C357.82 0 345.21 11.64 345.21 27.15C345.21 27.47 345.21 29.09 345.21 32L312.24 32C312.24 29.09 312.24 27.47 312.24 27.15C312.24 12.61 300.61 0 285.09 0C270.55 0 257.94 11.64 257.94 27.15C257.94 27.47 257.94 29.09 257.94 32L224.97 32C224.97 29.09 224.97 27.47 224.97 27.15C224.97 12.61 213.33 0 197.82 0C183.27 0 170.67 11.64 170.67 27.15C170.67 27.47 170.67 29.09 170.67 32L135.76 32C135.76 29.09 135.76 27.47 135.76 27.15C135.76 12.61 124.12 0 108.61 0C94.06 0.97 81.45 12.61 81.45 27.15C81.45 27.47 81.45 29.09 81.45 32C58.18 32 45.25 32 42.67 32C25.21 32 10.67 46.55 10.67 64C10.67 97.16 10.67 362.47 10.67 395.64C10.67 414.06 25.21 428.61 43.64 428.61C65.45 428.61 240 428.61 261.82 428.61C265.7 428.61 269.58 425.7 269.58 420.85C269.58 416 265.7 414.06 261.82 414.06C218.18 414.06 65.45 414.06 43.64 414.06ZM368.48 14.55C375.27 14.55 381.09 20.36 381.09 27.15C381.09 30.16 381.09 54.21 381.09 57.21C381.09 64 375.27 69.82 368.48 69.82C368.48 69.82 368.48 69.82 368.48 69.82C361.7 69.82 355.88 64 355.88 57.21C355.88 55.21 355.88 45.19 355.88 27.15C359.76 18.75 363.96 14.55 368.48 14.55ZM282.18 14.55C288.97 14.55 294.79 20.36 294.79 27.15C294.79 30.16 294.79 54.21 294.79 57.21C294.79 64 288.97 69.82 282.18 69.82C282.18 69.82 282.18 69.82 282.18 69.82C275.39 69.82 269.58 64 269.58 57.21C269.58 55.21 269.58 45.19 269.58 27.15C273.45 18.75 277.66 14.55 282.18 14.55ZM195.88 14.55C202.67 14.55 208.48 20.36 208.48 27.15C208.48 30.16 208.48 54.21 208.48 57.21C208.48 64 202.67 69.82 195.88 69.82C195.88 69.82 195.88 69.82 195.88 69.82C189.09 69.82 183.27 64 183.27 57.21C183.27 55.21 183.27 45.19 183.27 27.15C187.15 18.75 191.35 14.55 195.88 14.55ZM121.21 28.12C121.21 31.13 121.21 55.18 121.21 58.18C121.21 64.97 115.39 70.79 108.61 70.79C108.61 70.79 108.61 70.79 108.61 70.79C101.82 70.79 96 64.97 96 58.18C96 56.89 96 50.42 96 38.79C96 38.79 96 38.79 96 38.79C96 38.79 96 38.79 96 38.79C96 37.62 96 28.32 96 27.15C96 20.36 101.82 15.52 108.61 15.52C115.39 15.52 121.21 21.33 121.21 28.12Z",
    id: "c6VSr6YlVc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.3 459.64C278.3 556.61 356.85 635.15 453.82 635.15C550.79 635.15 629.33 556.61 629.33 459.64C629.33 362.67 550.79 284.12 453.82 284.12C356.85 284.12 278.3 362.67 278.3 459.64ZM292.85 460.61C292.85 372.36 364.61 298.67 453.82 298.67C543.03 298.67 614.79 371.39 614.79 459.64C614.79 547.88 542.06 621.58 453.82 621.58C364.61 621.58 292.85 548.85 292.85 460.61Z",
    id: "a6lfc3WBwZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.24 109.58C152.24 105.7 149.33 101.82 144.48 101.82C138.38 101.82 89.5 101.82 83.39 101.82C79.52 101.82 75.64 104.73 75.64 109.58C75.64 115.78 75.64 165.43 75.64 171.64C75.64 175.52 78.55 179.39 83.39 179.39C89.6 179.39 139.25 179.39 145.45 179.39C149.33 179.39 153.21 176.48 153.21 171.64C153.21 167.5 153.21 146.81 153.21 109.58C152.69 109.58 152.37 109.58 152.24 109.58ZM90.18 163.88L90.18 116.36L137.7 116.36L137.7 163.88L90.18 163.88Z",
    id: "a1fRxqns3o"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.61 109.58C268.61 105.7 265.7 101.82 260.85 101.82C254.64 101.82 204.99 101.82 198.79 101.82C194.91 101.82 191.03 104.73 191.03 109.58C191.03 115.78 191.03 165.43 191.03 171.64C191.03 175.52 193.94 179.39 198.79 179.39C205.09 179.39 255.52 179.39 261.82 179.39C265.7 179.39 269.58 176.48 269.58 171.64C269.58 167.5 269.58 146.81 269.58 109.58C269.06 109.58 268.74 109.58 268.61 109.58ZM206.55 163.88L206.55 116.36L254.06 116.36L254.06 163.88L206.55 163.88Z",
    id: "i1smG9rnFo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.21 101.82C371.01 101.82 321.36 101.82 315.15 101.82C311.27 101.82 307.39 104.73 307.39 109.58C307.39 115.78 307.39 165.43 307.39 171.64C307.39 175.52 310.3 179.39 315.15 179.39C321.36 179.39 371.01 179.39 377.21 179.39C381.09 179.39 384.97 176.48 384.97 171.64C384.97 167.5 384.97 146.81 384.97 109.58C383.03 104.4 380.44 101.82 377.21 101.82ZM322.91 163.88L322.91 116.36L370.42 116.36L370.42 163.88L322.91 163.88Z",
    id: "b27mYWVtn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.24 217.21C152.24 213.33 149.33 209.45 144.48 209.45C138.38 209.45 89.5 209.45 83.39 209.45C79.52 209.45 75.64 212.36 75.64 217.21C75.64 223.42 75.64 273.07 75.64 279.27C75.64 283.15 78.55 287.03 83.39 287.03C89.6 287.03 139.25 287.03 145.45 287.03C149.33 287.03 153.21 284.12 153.21 279.27C153.21 275.14 153.21 254.45 153.21 217.21C152.69 217.21 152.37 217.21 152.24 217.21ZM90.18 271.52L90.18 224L137.7 224L137.7 271.52L90.18 271.52Z",
    id: "c2vPKepCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.61 217.21C268.61 213.33 265.7 209.45 260.85 209.45C254.64 209.45 204.99 209.45 198.79 209.45C194.91 209.45 191.03 212.36 191.03 217.21C191.03 223.42 191.03 273.07 191.03 279.27C191.03 283.15 193.94 287.03 198.79 287.03C205.09 287.03 255.52 287.03 261.82 287.03C265.7 287.03 269.58 284.12 269.58 279.27C269.58 275.14 269.58 254.45 269.58 217.21C269.06 217.21 268.74 217.21 268.61 217.21ZM206.55 271.52L206.55 224L254.06 224L254.06 271.52L206.55 271.52Z",
    id: "b6vxNJROj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.15 209.45C311.27 209.45 307.39 212.36 307.39 217.21C307.39 223.42 307.39 273.07 307.39 279.27C307.39 283.15 310.3 287.03 315.15 287.03C321.36 287.03 371.01 287.03 377.21 287.03C381.09 287.03 384.97 284.12 384.97 279.27C384.97 273.07 384.97 223.42 384.97 217.21C384.97 213.33 382.06 209.45 377.21 209.45C364.8 209.45 321.36 209.45 315.15 209.45ZM322.91 271.52L322.91 224L370.42 224L370.42 271.52L322.91 271.52Z",
    id: "chNmtwPFR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.39 318.06C79.52 318.06 75.64 320.97 75.64 325.82C75.64 332.02 75.64 381.67 75.64 387.88C75.64 391.76 78.55 395.64 83.39 395.64C89.6 395.64 139.25 395.64 145.45 395.64C149.33 395.64 153.21 392.73 153.21 387.88C153.21 381.67 153.21 332.02 153.21 325.82C152.24 320.97 149.33 318.06 145.45 318.06C133.04 318.06 89.6 318.06 83.39 318.06ZM90.18 380.12L90.18 332.61L137.7 332.61L137.7 380.12L90.18 380.12Z",
    id: "iggqsLLvG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.76 318.06C195.88 318.06 192 320.97 192 325.82C192 332.02 192 381.67 192 387.88C192 391.76 194.91 395.64 199.76 395.64C205.96 395.64 255.61 395.64 261.82 395.64C265.7 395.64 269.58 392.73 269.58 387.88C269.58 381.67 269.58 332.02 269.58 325.82C268.61 320.97 265.7 318.06 261.82 318.06C249.41 318.06 205.96 318.06 199.76 318.06ZM206.55 380.12L206.55 332.61L254.06 332.61L254.06 380.12L206.55 380.12Z",
    id: "c2MRnne4ZK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.58 331.64C461.58 330.18 461.58 318.55 461.58 317.09C461.58 313.21 458.67 309.33 453.82 309.33C448.97 309.33 446.06 313.21 446.06 317.09C446.06 318.55 446.06 330.18 446.06 331.64C446.06 335.52 448.97 339.39 453.82 339.39C457.7 339.39 461.58 336.48 461.58 331.64Z",
    id: "f38yiXAJeA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.06 586.67C446.06 588.12 446.06 599.76 446.06 601.21C446.06 605.09 448.97 608.97 453.82 608.97C458.67 608.97 461.58 606.06 461.58 601.21C461.58 599.76 461.58 588.12 461.58 586.67C460.61 581.82 457.7 578.91 453.82 578.91C449.94 578.91 446.06 581.82 446.06 586.67Z",
    id: "a219CIVvo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.18 363.64C535.27 366.55 535.27 371.39 538.18 374.3C541.09 377.21 545.94 377.21 548.85 374.3C549.82 373.33 557.58 365.58 558.55 364.61C561.45 361.7 561.45 356.85 558.55 353.94C555.64 351.03 550.79 351.03 547.88 353.94C545.94 355.88 539.15 362.67 538.18 363.64Z",
    id: "cSo1uAXE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.09 553.7C346.18 556.61 346.18 561.45 349.09 564.36C352 567.27 356.85 567.27 359.76 564.36C360.73 563.39 368.48 555.64 369.45 554.67C372.36 551.76 372.36 546.91 369.45 544C366.55 541.09 361.7 541.09 358.79 544C356.85 545.94 350.06 552.73 349.09 553.7Z",
    id: "b2a1Nr7khl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.88 451.88C576 451.88 572.12 454.79 572.12 459.64C572.12 464.48 575.03 467.39 579.88 467.39C581.33 467.39 592.97 467.39 594.42 467.39C598.3 467.39 602.18 464.48 602.18 459.64C602.18 454.79 599.27 451.88 594.42 451.88C591.52 451.88 581.33 451.88 579.88 451.88Z",
    id: "cqI0QYUWl"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.27 451.88C307.39 451.88 303.52 454.79 303.52 459.64C303.52 464.48 306.42 467.39 311.27 467.39C312.73 467.39 324.36 467.39 325.82 467.39C329.7 467.39 333.58 464.48 333.58 459.64C333.58 454.79 330.67 451.88 325.82 451.88C322.91 451.88 312.73 451.88 311.27 451.88Z",
    id: "cXLQDrLws"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.18 544C535.27 546.91 535.27 551.76 538.18 554.67C539.15 555.64 546.91 563.39 547.88 564.36C550.79 567.27 555.64 567.27 558.55 564.36C561.45 561.45 561.45 556.61 558.55 553.7C557.9 553.05 554.67 549.82 548.85 544C543.68 542.06 540.12 542.06 538.18 544Z",
    id: "c2jA7M09OD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.12 353.94C345.21 356.85 345.21 361.7 348.12 364.61C349.09 365.58 356.85 373.33 357.82 374.3C360.73 377.21 365.58 377.21 368.48 374.3C371.39 371.39 371.39 366.55 368.48 363.64C367.84 362.99 364.61 359.76 358.79 353.94C353.62 352 350.06 352 348.12 353.94Z",
    id: "b36rVkHc3g"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.61 381.09C460.61 377.21 457.7 373.33 452.85 373.33C448 373.33 446.06 377.21 446.06 381.09C446.06 386.33 446.06 428.22 446.06 433.45C435.39 436.36 426.67 447.03 426.67 458.67C426.67 463.52 427.64 468.36 430.55 472.24C428.51 474.28 412.22 490.57 410.18 492.61C407.27 495.52 407.27 500.36 410.18 503.27C413.09 506.18 417.94 506.18 420.85 503.27C422.88 501.14 439.18 484.07 441.21 481.94C445.09 483.88 448.97 484.85 453.82 484.85C468.36 484.85 480 473.21 480 458.67C480 446.06 472.24 436.36 460.61 433.45C460.61 422.98 460.61 386.33 460.61 381.09ZM442.18 458.67C442.18 451.88 447.03 447.03 453.82 447.03C460.61 447.03 465.45 451.88 465.45 458.67C465.45 465.45 460.61 470.3 453.82 470.3C447.03 470.3 442.18 464.48 442.18 458.67Z",
    id: "b35O7wkGkE"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c6VSr6YlVc",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c6VSr6YlVc",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6lfc3WBwZ",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6lfc3WBwZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1fRxqns3o",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1fRxqns3o",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i1smG9rnFo",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i1smG9rnFo",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b27mYWVtn",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b27mYWVtn",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2vPKepCA",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2vPKepCA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6vxNJROj",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b6vxNJROj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chNmtwPFR",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chNmtwPFR",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iggqsLLvG",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#iggqsLLvG",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2MRnne4ZK",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2MRnne4ZK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f38yiXAJeA",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f38yiXAJeA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a219CIVvo",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a219CIVvo",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cSo1uAXE",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cSo1uAXE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2a1Nr7khl",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2a1Nr7khl",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cqI0QYUWl",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cqI0QYUWl",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cXLQDrLws",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cXLQDrLws",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2jA7M09OD",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c2jA7M09OD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b36rVkHc3g",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b36rVkHc3g",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b35O7wkGkE",
    opacity: 1,
    fill: "#000100",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b35O7wkGkE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch2);
export default __webpack_public_path__ + "static/media/switch-2.f948a0ce08f4feb2e3ab3abfd0fdaa0b.svg";
export { ForwardRef as ReactComponent };